import { PARTNER_ADDED_FROM } from './partnerAddedFrom';
import { PARTNER_SUBSCRIPTION_PATH } from './partnerSubscriptionPlans';

/** Manage Subscription is only for partners who joined via the website. */
export const canShowPartnerSubscriptionNav = (partnerProfile) =>
  partnerProfile?.addedFrom === PARTNER_ADDED_FROM.WEBSITE;

/**
 * Website partners must have an active currentPlan before using the rest of the portal.
 * Call only after plans have loaded successfully.
 */
export const isPartnerSubscriptionRequired = (partnerProfile, currentPlan) =>
  canShowPartnerSubscriptionNav(partnerProfile) && currentPlan == null;

export const isPartnerSubscriptionPath = (pathname = '') =>
  String(pathname).startsWith(PARTNER_SUBSCRIPTION_PATH);

export { PARTNER_SUBSCRIPTION_PATH };
